export function SettingsCookiesRoute($stateProvider) {
	'ngInject';
	$stateProvider.state('hub.loggedin.SettingsCookies', {
		url: '/preferences/cookies',
		controllerAs: 'vm',
		controller: SettingsCookiesCtrl,
		templateUrl: '/ng/hub/Settings/Cookies/SettingsCookiesCtrl.html?' + window.BUILD,
		permission: ['login'],
		resolve: {
			$title: () => 'Cookie Settings',
		},
	});
}

export class SettingsCookiesCtrl {
	constructor() {
		'ngInject';
	}
}
